<mat-expansion-panel class="ticket-container">
  <div></div>
</mat-expansion-panel>
